"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const formatErrors = checks => {
  return Object.keys(checks).reduce((accumulator, key) => {
    if (checks[key] !== true) {
      accumulator[key] = checks[key];
    }

    return accumulator;
  }, {});
};

var _default = formatErrors;
exports.default = _default;